import {
  bundleIcon,
  Gavel24Filled,
  Gavel24Regular,
} from '@fluentui/react-icons';

import {
  useGraderActions,
  useGraderState,
} from '../../../context/GraderContext';
import { GraderDetailView } from '../GraderDetailView/GraderDetailView';
import { useStyles } from '../GraderPage.style';

const GavelIcon = bundleIcon(Gavel24Filled, Gavel24Regular) as React.FC;

// Renders the center panel content for view mode. The page owns the
// panelsRow div + GraderList rail (which is shared across both modes).
export function ViewLayout() {
  const styles = useStyles();
  const { editorTab, selectedGrader, workspaceName } = useGraderState();
  const { setEditorTab } = useGraderActions();

  return (
    <div className={styles.centerPanel}>
      {selectedGrader === null ? (
        <div className={styles.centerEmpty}>
          <div className={styles.centerEmptyIcon}>
            <GavelIcon />
          </div>
          <span className={styles.centerEmptyText}>Select a judge to edit</span>
          <span className={styles.centerEmptySub}>
            Choose a judge from the list, or create a new one to get started.
          </span>
        </div>
      ) : (
        <GraderDetailView
          judge={selectedGrader}
          activeTab={editorTab}
          onTabChange={setEditorTab}
          workspaceName={workspaceName}
        />
      )}
    </div>
  );
}
